import React, { useState, useEffect, useRef } from "react";
import Clientsidebar from "../components/Clientsidebar";
import Clientheader from "../components/Clientheader";
import axios from "axios";
import Cookies from "js-cookie";
import { jwtDecode } from "jwt-decode";
import { useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./Clientdocuments.css";
import { useYearContext } from "../../admin/components/YearContext";
import { toast } from "react-toastify";

function Clientdocuments() {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("client");
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [selectedComment, setSelectedComment] = useState("");
  const [username, setUsername] = useState("");
  const [clientDocuments, setClientDocuments] = useState([]);
  const fileInputRef = useRef(null);
  const [role, setRole] = useState("");

  const token = Cookies.get("token");
  useEffect(() => {
    if (!token) {
      navigate("/login");
    } else {
      try {
        const decoded = jwtDecode(token);
        setUsername(decoded.email);
        setRole(decoded.role);

        if (decoded.role !== "client") {
          // navigate("/");
        }
      } catch (error) {
        console.error("Invalid token");
        // navigate("/");
      }
    }
  }, []);

  // Handle switching tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  // useEffect(() => {
  //   fetchclientdocuments();
  // }, [username]);


  useEffect(() => {
  if (username && yearSelected) {
    fetchclientdocuments();
  }
}, [username, yearSelected]);

  // const fetchclientdocuments = async () => {
  //   await axios
  //     .get(` https://api.easytaxexperts.com/clientDocuments/${username}`)

  //     .then((response) => {
  //       if (response.data.success) {
  //         setClientDocuments(response.data.clientDocuments);
  //       } else {
  //         console.error(
  //           "Error fetching client documents:",
  //           response.data.message
  //         );
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching client documents:", error);
  //     });
  // };


  const fetchclientdocuments = async () => {
  try {
    const res = await axios.get(`https://api.easytaxexperts.com/clientDocuments/${username}?taxyear=${yearSelected}`);
    if (res.data.success) setClientDocuments(res.data.clientDocuments);
  } catch (err) {
    console.error(err);
  }
};

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleDocumentTypeChange = (e) => {
    setSelectedDocumentType(e.target.value);
  };

  const handleCommentChange = (e) => {
    setSelectedComment(e.target.value);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!selectedDocumentType || !selectedFile) {
  //     toast.warn("Please fill all required fields");
  //     return;
  //   }

  //   try {
  //     const formData = new FormData();
  //     formData.append("username", username);
  //     formData.append("document_type", selectedDocumentType);
  //     formData.append("file", selectedFile);
  //     formData.append("add_comment", selectedComment);

  //     const response = await axios.post(
  //       " https://api.easytaxexperts.com/clientuploadeddocs",
  //       formData,
  //     );

  //     if (response.data.success) {
  //       toast.success("Document submitted successfully");
  //       window.location.reload();

  //       setSelectedFile(null);
  //       setSelectedDocumentType("");
  //       setSelectedComment("");
  //     } else {
  //       toast.error("Error submitting document");
  //     }
  //   } catch (error) {
  //     console.error("Error during document submission:", error);
  //   }
  // };


// Inside handleSubmit function
const handleSubmit = async (e) => {
  e.preventDefault();
  if (!selectedDocumentType || !selectedFile) {
    toast.warn("Please fill all required fields");
    return;
  }

  try {
    const formData = new FormData();
    formData.append("username", username);
    formData.append("document_type", selectedDocumentType);
    formData.append("file", selectedFile);
    formData.append("add_comment", selectedComment);
    formData.append("taxyear", yearSelected); // <-- IMPORTANT

    const res = await axios.post("https://api.easytaxexperts.com/clientuploadeddocs", formData);
    if (res.data.success) {
      toast.success("Document uploaded successfully");
      fetchclientdocuments(); // refresh documents
      setSelectedFile(null);
      setSelectedDocumentType("");
      setSelectedComment("");
      handleClose();
    }
  } catch (err) {
    console.error(err);
  }
};


  const handleDownloaddoc = (filePath) => {
    // Replace backslashes with forward slashes in the filePath
    const formattedFilePath = filePath.replace(/\\/g, "/");
  
    // Construct the download URL based on the formatted filePath
    const downloadUrl = `https://api.easytaxexperts.com/${formattedFilePath}`;
  
    // Fetch the file to ensure it's downloadable as a blob
    fetch(downloadUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch the file");
        }
        return response.blob(); // Get the file as a blob
      })
      .then((blob) => {
        // Create a temporary URL for the blob
        const blobUrl = URL.createObjectURL(blob);
  
        // Create a temporary link
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = formattedFilePath.split("/").pop(); // Set the file name
  
        // Append the link to the body
        document.body.appendChild(link);
  
        // Programmatically click on the link to trigger the download
        link.click();
  
        // Clean up by revoking the blob URL and removing the link
        URL.revokeObjectURL(blobUrl);
        document.body.removeChild(link);
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };
  

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

//   const filterDocuments = clientDocuments.filter((doc) => {
//     const documentDate = doc.uploaded_on
//       ? doc.uploaded_on.substring(0, 10)
//       : "";
//     const nextYear = (parseInt(yearSelected) + 1).toString();
//     // const startDate = `${parseInt(nextYear) - 1}-09-01`;
//     // const endDate = `${nextYear}-08-31`;
//     const startDate = `${yearSelected}-11-30`;
// const endDate = `${Number(yearSelected) + 1}-11-29`;

//     const isYearMatch = documentDate >= startDate && documentDate <= endDate;
//     return isYearMatch;
//   });



const filterDocuments = clientDocuments.filter(
  (doc) => doc.taxyear?.toString() === yearSelected.toString()
);

// const filterDocuments = clientDocuments.filter((doc) => {
//   const docDate = new Date(doc.uploaded_on); // or whatever date field you have
//   const startYear = parseInt(yearSelected);
//   const startDate = new Date(`${startYear}-11-01`);
//   const endDate = new Date(`${startYear + 1}-10-31`);
  
//   return docDate >= startDate && docDate <= endDate;
// });

const reverseDocument = filterDocuments.slice().reverse();
  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 100;
  const lastIndex = currentPage * recordsPerPage;
  const firstIndex = lastIndex - recordsPerPage;
  const records = reverseDocument.slice(firstIndex, lastIndex);
  const npage = Math.ceil(filterDocuments.length / recordsPerPage);
  const numbers = [...Array(npage + 1).keys()].slice(1);

  const prePage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  const changeCpage = (id) => {
    setCurrentPage(id);
  };
  const nextPage = () => {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  };

  return (
    <div className="client-grid-container">
      <Clientheader openSidebar={openSidebar} />
      <Clientsidebar
        openSidebarToggle={openSidebarToggle}
        openSidebar={openSidebar}
      />
      <main className="main-container mt-2">
        <div className="container">
          <div>
            <h4>Documents</h4>

            <div>
              <div>
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleShow}
                >
                  Upload Document
                </button>
              </div>

              <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Document</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="form-group">
                    <label htmlFor="dropdownInput">Document Type:</label>
                    <select
                      className="form-control"
                      id="dropdownInput"
                      name="dropdownInput"
                      onChange={handleDocumentTypeChange}
                      value={selectedDocumentType}
                    >
                      <option value="" disabled>
                        Select Document Type
                      </option>
                      <optgroup label="Income Forms" className="red-label">
                        <option value="W-2 - Wage and salary income">W-2 - Wage and salary income.</option>
                        <option value="W-2C - Corrected Wage and Tax Statement">W-2C - Corrected Wage and Tax Statement.</option>
                        <option value="W2-G - Certain Gambling Winnings">
                        W2-G - Certain Gambling Winnings.
                        </option>
                        <option value="1042-S - Foreign person's U.S. source income">1042-S - Foreign person's U.S. source income.</option>
                       
                      </optgroup>
                      <optgroup label="Foreign Wage Statement" className="red-label">
                        <option value="K-1  - Income from partnerships, S corporations, estates, or trusts">
                        K-1  - Income from partnerships, S corporations, estates, or trusts.
                        </option>
                        <option value="1099-INT - Interest income">
                        1099-INT - Interest income.
                        </option>
                        <option value="1099-DIV - Dividend income">
                        1099-DIV - Dividend income.
                        </option>
                        <option value="1099-B - Proceeds from Broker and Barter Exchange Transactions">
                        1099-B - Proceeds from Broker and Barter Exchange Transactions.
                        </option>
                        <option value="1099-NEC - Non-employee compensation">
                        1099-NEC - Non-employee compensation.
                        </option>
                        <option value="1099-MISC -Miscellaneous Income">
                        1099-MISC -Miscellaneous Income.
                        </option>
                        <option value="1099-G - Certain Government Payments">
                        1099-G - Certain Government Payments.
                        </option>
                        <option value="1099-R - Distributions from Pensions, Annuities, Retirement Plans, IRAs, etc">
                        1099-R - Distributions from Pensions, Annuities, Retirement Plans, IRAs, etc.
                        </option>
                        <option value="1099-K -Payment Card and Third-Party Network Transactions">
                        1099-K -Payment Card and Third-Party Network Transactions.
                        </option>
                        <option value="1095-A - Health Insurance Marketplace Statement">
                        1095-A - Health Insurance Marketplace Statement.
                        </option>
                        <option value="1099-S -Proceeds From Real Estate Transactions">
                        1099-S -Proceeds From Real Estate Transactions.
                        </option>
                        <option value="1099-SA -Distributions from Health Savings Accounts (HSAs) or Archer MSAs">
                        1099-SA -Distributions from Health Savings Accounts (HSAs) or Archer MSAs.
                        </option>
                        <option value="1099-C -Cancellation of Debt (discharged debt may be considered taxable income)">
                        1099-C -Cancellation of Debt (discharged debt may be considered taxable income).
                        </option>
                        <option value="1099-LTC - Long-Term Care and Accelerated Death Benefits">
                        1099-LTC - Long-Term Care and Accelerated Death Benefits.
                        </option>
                        <option value="1099-RRB - Railroad Retirement Benefits">
                        1099-RRB - Railroad Retirement Benefits.
                        </option>
                        <option value="1099-Q - Payments from Qualified Education Programs">
                        1099-Q - Payments from Qualified Education Programs.
                        </option>
                      </optgroup>
                      <optgroup label="Expense Forms" className="red-label">
                        <option value="1098 - Mortgage interest payments">1098 - Mortgage interest payments.</option>
                        <option value="1098-T -Tuition Statement">1098-T -Tuition Statement</option>
                        <option value="1098-E -Student Loan Interest Statement">1098-E -Student Loan Interest Statement</option>
                        <option value="1098-F -Fines, Penalties, and Other Amounts">1098-F -Fines, Penalties, and Other Amounts</option>
                        <option value="1098-C -Contributions of Motor Vehicles, Boats, and Airplanes">1098-C -Contributions of Motor Vehicles, Boats, and Airplanes</option>
                        <option value="Foreign Home Interest Certificate/Statement From Bank">Foreign Home Interest Certificate/Statement From Bank</option>
                       
                      </optgroup>
                      <optgroup label="Others" className="red-label">
                        <option value="Tax Organizer">Tax Organizer</option>
                        <option value="Prior Year Tax Return Copy">Prior Year Tax Return Copy</option>
                        <option value="Tax Summary">Tax Summary</option>
                        <option value="Client Copy">Client Copy</option>
                        <option value="IDS">IDS</option>
                        <option value="Final Draft">Final Draft</option>
                        <option value="Paper Filing Instructions">Paper Filing Instructions</option>
                        <option value="Other Documents">Other Documents</option>                       
                      </optgroup>
                    </select>
                  </div>
                  <div className="form-group mt-3">
                    <label htmlFor="fileInput">Upload File:</label>
                    <input
                      ref={fileInputRef}
                      type="file"
                      className="form-control-file"
                      id="fileInput"
                      name="fileInput"
                      onChange={handleFileChange}
                    />
                  </div>
                  <div className="form-group mt-3">
                    <label htmlFor="commentInput">Add Comment:</label>
                    <textarea
                      className="form-control"
                      id="commentInput"
                      name="commentInput"
                      rows="3"
                      onChange={handleCommentChange}
                      value={selectedComment}
                    ></textarea>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={handleClose}>
                    Close
                  </Button>
                  <Button variant="primary" onClick={(e) => handleSubmit(e)}>
                    Save Changes
                  </Button>
                </Modal.Footer>
              </Modal>
            </div>

            <div>
              <ul
                className="nav nav-tabs mt-3 doctabs"
                id="myTab"
                role="tablist"
              >
                <li class="nav-item" role="presentation">
                  <a
                    className={`doclinks nav-link ${
                      activeTab === "client" ? "active" : ""
                    }`}
                    id="home-tab"
                    data-toggle="tab"
                    href="#home"
                    role="tab"
                    aria-controls="home"
                    aria-selected={activeTab === "client"}
                    onClick={() => handleTabChange("client")}
                  >
                    Client Uploaded Documents
                  </a>
                </li>
                <li class="nav-item" role="presentation">
                  <a
                    className={`doclinks nav-link ${
                      activeTab === "taxExpert" ? "active" : ""
                    }`}
                    id="profile-tab"
                    data-toggle="tab"
                    href="#profile"
                    role="tab"
                    aria-controls="profile"
                    aria-selected={activeTab === "taxExpert"}
                    onClick={() => handleTabChange("taxExpert")}
                  >
                    Tax Experts Uploaded Documents
                  </a>
                </li>
              </ul>

              <div class="tab-content" id="myTabContent">
                <div
                  className={`tab-pane fade ${
                    activeTab === "client" ? "show active" : ""
                  }`}
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div className="table-container">
                    <div className="table-responsive tablediv">
                      <table className="table table-bordered table-hover">
                        <thead className="table-primary">
                          <tr>
                            <th>S.No</th>
                            <th>Document Type</th>
                            {/* <th>Uploaded On</th>
                            <th>Uploaded By</th> */}
                            <th>Comments</th>
                            <th>Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          {records
                            .filter((document) => document.uploaded_client)
                            .map((document, index) => (
                              <tr key={index}>
                                <td>{(currentPage - 1) * recordsPerPage + index + 1 }</td>
                                <td>{document.type}</td>
                                {/* <td>{document.uploaded_on}</td>
                                <td>{document.uploaded_client}</td> */}
                                <td>{document.comments}</td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    title="Download PDF"
                                    onClick={() => {
                                      
                                      handleDownloaddoc(
                                        document.filePath.trim()
                                      );
                                    }}
                                  >
                                    Download
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                {/* Tax Expert Uploaded Documents Tab */}
                <div
                  className={`tab-pane fade ${
                    activeTab === "taxExpert" ? "show active" : ""
                  }`}
                  id="profile"
                  role="tabpanel"
                  aria-labelledby="profile-tab"
                >
                  <div className="table-container">
                    <div className="table-responsive tablediv">
                      <table className="table table-bordered table-hover">
                        <thead className="table-primary">
                          <tr>
                            <th>S.No</th>
                            <th>Document Type</th>
                            {/* <th>Uploaded On</th>
                            <th>Uploaded By</th> */}
                            <th>Comments</th>
                            <th>Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          {records
                            .filter(
                              (document) =>
                                document.uploaded_employee ||
                                document.uploaded_admin
                            )
                            .map((document, index) => (
                              <tr key={index}>
                                <td>{(currentPage - 1) * recordsPerPage + index + 1}</td>
                                <td>{document.type}</td>
                                {/* <td>{document.uploaded_on}</td>
                                <td>
                                  {document.uploaded_employee ||
                                    document.uploaded_admin}
                                </td> */}
                                <td>{document.comments}</td>
                                <td>
                                  <button
                                    className="btn btn-primary"
                                    title="Download PDF"
                                    onClick={() => {
                                      
                                      handleDownloaddoc(
                                        document.filePath.trim()
                                      );
                                    }}
                                  >
                                    Download
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <nav className="mt-2">
                <ul className="pagination">
                  <li className="page-item">
                    <a href="#" className="page-link" onClick={prePage}>
                      Prev
                    </a>
                  </li>
                  {numbers.map((n, i) => {
                    return (
                      <li
                        className={`page-item ${
                          currentPage === n ? "active" : ""
                        }`}
                        key={i}
                      >
                        <a
                          href="#"
                          className="page-link"
                          onClick={() => changeCpage(n)}
                        >
                          {n}
                        </a>
                      </li>
                    );
                  })}
                  <li className="page-item">
                    <a href="#" className="page-link" onClick={nextPage}>
                      Next
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default Clientdocuments;

